<template>
  <nuxt-layout>
    <ErrorPage404 v-if="error.statusCode === 404" :error="error" />
    <ErrorPage v-else :error="error" />
  </nuxt-layout>
</template>
<script lang="ts" setup>
const props = defineProps({
  error: Object,
});
</script>
